export default function ({ store, redirect }) {
  const isTrialLead = store.state.user.details?.leadType === 'trialLead'
  const didFreeTrial = store.state.checkout.didFreeTrial

  if (!isTrialLead || didFreeTrial) {
    redirect('/recommendations')
  }
}
